import { FileStatus } from "fe-shared/src/types/common";
import { Retreader } from "fe-shared-transactions/src/types";
import { getTransformDecimalValue } from "fe-shared/src/helpers/transform";
import { RetreadingTransactionFormContent } from "../../../types";

interface Option {
  label: string;
  value: string | number;
}

const monthFormat = new Intl.DateTimeFormat("en-CA", { month: "long" });

export const yearOptions = ((): Option[] => {
  const endYear = new Date().getFullYear();
  const startYear = endYear - 1;
  const length = endYear - startYear + 1;

  return Array.from({ length }, (_, i) => startYear + i).map((year) => ({
    label: String(year),
    value: year,
  }));
})();

export const getPeriodMonthOptions = (year: number): Option[] => {
  const options: Option[] = [];
  const today = new Date();
  const MAX_MONTH = year < today.getFullYear() ? 11 : today.getMonth();

  for (let monthNumber = 0; monthNumber <= MAX_MONTH; monthNumber++) {
    const date = new Date(Date.UTC(year, monthNumber, 1));
    const month = monthFormat.format(date);

    options.push({
      value: month,
      label: month,
    });
  }

  return options;
};

export const convertTransactionToForm = (
  transaction: Retreader
): { [key: string]: unknown } => {
  const {
    collectionInfoMaterials,
    retreadRepairInfoMaterials,
    recoveryInfoMaterials,
    isKnownRetreaderTiresActualWeight,
    retreadingPeriodDate,
    sourceWarehouse,
    attachments,
    ...rest
  } = transaction;
  const periodDate = new Date(retreadingPeriodDate);
  const { participant } = sourceWarehouse!;

  return {
    collectionInfoMaterials: collectionInfoMaterials.reduce((acc, material) => {
      acc[material.materialCode] = isKnownRetreaderTiresActualWeight
        ? material.units.weight
        : material.units.unitQuantity;

      return acc;
    }, {} as RetreadingTransactionFormContent),
    retreadRepairInfoMaterials: retreadRepairInfoMaterials.reduce(
      (acc, material) => {
        acc[material.materialCode] = material.units.weight;

        return acc;
      },
      {} as RetreadingTransactionFormContent
    ),
    recoveryInfoMaterials: recoveryInfoMaterials.reduce((acc, material) => {
      acc[material.materialCode] = material.units.weight;

      return acc;
    }, {} as RetreadingTransactionFormContent),
    isKnownRetreaderTiresActualWeight,
    periodYear: periodDate.getFullYear(),
    periodMonth: monthFormat.format(periodDate),
    companyId: participant.companyId,
    companyName: participant.displayName,
    attachments: (attachments || []).map((item) => ({
      ...item,
      path: item.documentPath,
      id: item.documentPath,
      status: FileStatus.Loaded,
    })),
    ...rest,
  };
};

export const transformIntegerValue = getTransformDecimalValue(8, 0);

export default {
  getPeriodMonthOptions,
  convertTransactionToForm,
  yearOptions,
  transformIntegerValue,
};
